import { faker } from '@faker-js/faker'

import { getRewardRule } from './RewardRule'

import { PointRewards } from '../../contracts/service-offer'
import { asBuilder } from '../asBuilder'

export const getPointRewards = asBuilder((): PointRewards => {
  return {
    totalPointReward: {
      paybackPercentage: faker.number.int({ min: 1, max: 100 }),
      amount: faker.number.int(),
    },
    rewards: faker.helpers.multiple(getRewardRule),
  }
})
